import type { ThemeOptions } from '@mui/material/styles';
import { APP_FONT_FAMILY_VAR } from './fonts';

export { APP_TEXT_COLOR } from './colors';

/**
 * Typography matches the Zero platform: Inter + Noto Sans multi-script stack
 * with MUI's default type scale (14px theme base).
 *
 * Local style modules may still use these tokens for tables / compact UI.
 * Values follow MUI defaults so explicit sizes stay aligned with the theme.
 */
export const APP_FONT_SIZE = {
  xs: '0.75rem', // 12px — caption
  sm: '0.875rem', // 14px — body2 / tables / compact UI
  md: '1rem', // 16px — body1
  lg: '1.25rem',
  xl: '2.125rem', // h4
} as const;

export const APP_LINE_HEIGHT = {
  tight: 1.235,
  normal: 1.5,
  relaxed: 1.75,
} as const;

/** Weight + Zero/Ops font stack; heading sizes stay MUI defaults. */
export const appTypography: ThemeOptions['typography'] = {
  fontFamily: APP_FONT_FAMILY_VAR,
  h1: { fontWeight: 700 },
  h2: { fontWeight: 700 },
  h3: { fontWeight: 600 },
  h4: { fontWeight: 600 },
  h5: { fontWeight: 600 },
  h6: { fontWeight: 600 },
};

export const appTypographyComponents: ThemeOptions['components'] = {
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        fontFamily: APP_FONT_FAMILY_VAR,
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        fontWeight: 600,
      },
    },
  },
};
